import { ChangeDetectorRef, Component, Input, OnChanges } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { CountryShared } from '../../../models/interface/country.interface';
import { ItemNumberToFilterShared } from '../../../models/interface/itemNumberToFilter.interface';
import { MuLayoutService } from '../../../sharedProtos/layout/mu-layout.service';
import { FormControlValidatorService } from '../../../sharedServices/form-control-validator.service';
import { UtilsService } from '../../../sharedServices/utils.service';
import { Flags } from '../../../types/flags.type';
import { MuComponent } from '../../../types/MuComponent.componetent';
import { ValidatorService } from '../../validator/validator.service';

@Component({
  selector: 'app-mu-modal-cancel',
  templateUrl: './mu-modal-cancel.component.html',
  styleUrls: ['./mu-modal-cancel.component.sass'],
})
export class MuModalCancelComponent<FlagType> extends MuComponent implements OnChanges {
  @Input() formData: UntypedFormGroup;
  @Input() showFlag: FlagType;
  @Input() actionFlag: FlagType;
  @Input() loaderFlag: FlagType;
  @Input() flagList: Flags<FlagType>;
  @Input() cancellationTypeList: ItemNumberToFilterShared[];
  @Input() cancellationKey: string;
  @Input() cancellationLink: string;
  @Input() cancellationValue: string;
  @Input() title: string;
  @Input() hideCancel: boolean;
  @Input() actionLabel: string;
  @Input() showCloseIcon:boolean = true;
  @Input() contentModalInnerHtml:string;
  @Input() cancelLabel: string = 'page.delivery.orders.cancel.cancel';
  @Input() cancellationTypeField = 'cancellationType';
  @Input() descriptionField = 'description';
  country: CountryShared;
  isCancelDescription: string[] = environment.shared.isCancelDescription;

  constructor(
    public utils: UtilsService,
    private customValidator: FormControlValidatorService,
    private layoutService: MuLayoutService,
    public changeDetectorRef: ChangeDetectorRef,
    public validatorService: ValidatorService
  ) {
    super();
  }

  async muOnInit(): Promise<void> {
    this.country = await this.layoutService.getCountry();
  }

  muOnDestroy(): void {
    /** */
  }

  ngOnChanges(): void {
    if (this.formData && this.cancellationTypeList) {
      this.watch(this.formData.get(this.cancellationTypeField).valueChanges).subscribe((value: number) => {
        let validators = [];
        if (this.isCancelDescription.includes(value + '')) {
          validators.push(Validators.required);
          validators = [Validators.required, this.customValidator.minLength(3)];
        }
        this.formData.get(this.descriptionField).setValidators(validators);
        this.formData.get(this.descriptionField).setValue('');
        this.formData.get('isInvalidForm').setValue(validators.length > 0);
      });
    }
  }

  /**
   * get show modal
   */
  getShowModalState(): boolean {
    return this.flagList ? this.flagList.get(this.showFlag) : false;
  }
}
